import { createFileRoute } from '@tanstack/react-router';
import { PrivacyNoticePage } from '@/features/organization/privacy/privacy-notice-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/privacy')({
    staticData: { crumbs: [{ label: 'settings.nav.privacy' }] },
    component: function PrivacyNoticeRoute() {
        const { organizationId } = Route.useParams();
        return <PrivacyNoticePage organizationId={organizationId} />;
    },
});
